import template from './reportes.html';
import { FormActions } from 'core/services/form';
import reportesI18N from 'i18n/reportes/es.json';
import configFile from 'config.json';
import { download, pad } from 'core/util';
import { rest } from 'core/api';


export let ReportesComponent = {
  templateUrl: template,
  selector: 'reportes',
  bindings: {
    translations: '='
  },
  controller: ReportesCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(reportesI18N).concat(commonsI18N);

ReportesCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', 'ngNotify', 'Filter', '$window', '$scope', '$resource', 'HeadersUtil'
];

function ReportesCtrl(BasicFactory, $ngRedux, $state, ngNotify, Filter, $window, $scope, $resource, HeadersUtil) {

  Object.assign(this, { $state, $ngRedux, ngNotify });
  this.defaultDateFormat = configFile.defaultDateFormat;

  this.mapStateToThis = mapStateToThis.bind(this);
  this.onChangeDate = onChangeDate.bind(this);
  this.onChangeDateServicio = onChangeDateServicio.bind(this);
  this.doSubmit = doSubmit.bind(this);

  const familiaFilter = Filter.path('ultimoNivel').eq(true)
  const valoresEstadoProductoFilter = Filter.path('tipo.codigo').eq('estado_activacion');

  let unsubscribe;

  this.$onDestroy = () => {
    this.form();
    $ngRedux.dispatch(rest.actions.valores.reset());
    $ngRedux.dispatch(rest.actions.familiasProductos.reset());
    $ngRedux.dispatch(rest.actions.proveedores.reset());
    $ngRedux.dispatch(rest.actions.marcas.reset());
    unsubscribe();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
    this.form();
    $ngRedux.dispatch(rest.actions.sucursales.get());
    $ngRedux.dispatch(rest.actions.familiasProductos({ filter: JSON.stringify(familiaFilter) }));
    $ngRedux.dispatch(rest.actions.proveedores({}));
    $ngRedux.dispatch(rest.actions.marcas({}));
    $ngRedux.dispatch(rest.actions.valores.get({ filter: JSON.stringify(valoresEstadoProductoFilter) }));

  };

  function mapStateToThis(state) {
    return {
      form: state.form,
      sucursales: state.sucursales.data,
      familiasProductos: state.familiasProductos.data,
      proveedores: state.proveedores.data,
      marcas: state.marcas.data,
      estadosProductos: state.valores.data.filter((v) => v.tipo.codigo === 'estado_activacion')
    };
  }

  this.tiposReportes = [
    {
      value: 'LIBRO_IVA',
      name: 'Libro IVA',
      url: 'reportes-libro-iva',
      formatos: [
        {
          value: 'pdf',
          name: 'Archivo PDF'
        },
        {
          value: 'xlsx',
          name: 'Archivo Excel'
        },
        {
          value: 'csv',
          name: 'CSV'
        }
      ]
    },
    {
      value: 'DESCUENTO_CONCEDIDO',
      name: 'Descuento Concedido',
      url: 'reportes-descuento',
      formatos: [
        {
          value: 'pdf',
          name: 'Archivo PDF'
        },
        {
          value: 'xlsx',
          name: 'Archivo Excel'
        },
        {
          value: 'csv',
          name: 'CSV'
        }
      ]
    },
    {
      value: 'COMISION_VENTA',
      name: 'Comisiones Venta Productos',
      url: 'reportes-comision-venta',
      action: 'producto',
      formatos: [
        {
          value: 'pdf',
          name: 'Archivo PDF'
        },
        {
          value: 'xlsx',
          name: 'Archivo Excel'
        },
        {
          value: 'csv',
          name: 'CSV'
        }
      ]
    },
    {
      value: 'COMISION_VENTA',
      name: 'Comisiones Venta Productos y Servicios',
      url: 'reportes-comision-venta',
      action: 'todas',
      formatos: [
        {
          value: 'pdf',
          name: 'Archivo PDF'
        },
        {
          value: 'xlsx',
          name: 'Archivo Excel'
        },
        {
          value: 'csv',
          name: 'CSV'
        }
      ]
    },
    {
      value: 'COMISION_VENTA',
      name: 'Comisiones por Servicios',
      url: 'reportes-comision-venta',
      action: 'servicio',
      formatos: [
        {
          value: 'pdf',
          name: 'Archivo PDF'
        },
        {
          value: 'xlsx',
          name: 'Archivo Excel'
        },
        {
          value: 'csv',
          name: 'CSV'
        }
      ]
    },
    {
      value: 'USO_INSUMO_GENERAL',
      name: 'Registro de Insumos',
      url: 'reportes-uso-insumo',
      action: 'general',
      formatos: [
        {
          value: 'pdf',
          name: 'Archivo PDF'
        },
        {
          value: 'xlsx',
          name: 'Archivo Excel'
        },
        {
          value: 'csv',
          name: 'CSV'
        }
      ]
    },
    {
      value: 'USO_INSUMO_SERVICIO',
      name: 'Servicios por registro de Insumos',
      url: 'reportes-uso-insumo',
      action: 'servicio',
      formatos: [
        {
          value: 'pdf',
          name: 'Archivo PDF'
        },
        {
          value: 'xlsx',
          name: 'Archivo Excel'
        },
        {
          value: 'csv',
          name: 'CSV'
        }
      ]
    },
    {
      value: 'VENTA_PRODUCTOS',
      name: 'Venta de Productos',
      url: 'reportes-venta-productos',
      formatos: [
        {
          value: 'pdf',
          name: 'Archivo PDF'
        },
        {
          value: 'xlsx',
          name: 'Archivo Excel'
        },
        {
          value: 'csv',
          name: 'CSV'
        }
      ]
    },
    {
      value: 'VENTA_CLIENTE',
      name: 'Ventas por Clientes',
      url: 'reportes-venta-cliente',
      formatos: [
        {
          value: 'pdf',
          name: 'Archivo PDF'
        },
        {
          value: 'xlsx',
          name: 'Archivo Excel'
        },
        {
          value: 'csv',
          name: 'CSV'
        }
      ]
    },
    {
      value: 'VENTA_MARCA_VENDEDOR',
      name: 'Ventas por Marcas y Vendedor',
      url: 'reportes-venta-marca-vendedor',
      formatos: [
        {
          value: 'pdf',
          name: 'Archivo PDF'
        },
        {
          value: 'xlsx',
          name: 'Archivo Excel'
        },
        {
          value: 'csv',
          name: 'CSV'
        }
      ]
    }
  ];

  this.formatos = [
    {
      value: 'pdf',
      name: 'Archivo PDF'
    },
    {
      value: 'csv',
      name: 'Archivo CSV'
    },
    {
      value: 'xlsx',
      name: 'Archivo Excel'
    }
  ];

  this.localModel = {
    hastaOptions: {},
    desdeOptions: {},
    hastaOptionsServicio: {},
    desdeOptionsServicio: {},
    formato: this.formatos[0],
    tipoReporte: this.tiposReportes[0],
    usoInsumoFilter: {}
  };

  function onChangeDate() {
    if (this.model) {
      this.localModel.desdeOptions.maxDate = this.model.hasta;
      this.localModel.hastaOptions.minDate = this.model.desde;
    }
  }

  function onChangeDateServicio() {
    if (this.model) {
      this.localModel.hastaOptionsServicio.maxDate = this.model.hastaServicio;
      this.localModel.hastaOptionsServicio.minDate = this.model.desdeServicio;
    }
  }


  function doSubmit() {
    if ($scope.reporteForm.$invalid) {
      this.submitted = true;
      return;
    }

    let data = this.getData();
    data.tipo = this.localModel.formato.value;
    download('reportes', this.localModel.tipoReporte.url, this.localModel.tipoReporte.action, configFile, $resource, HeadersUtil, data);
  }

  this.getData = getData.bind(this);
  function getData() {
    let data;
    if (['USO_INSUMO_GENERAL', 'USO_INSUMO_SERVICIO'].includes(this.localModel.tipoReporte.value)) {
      data = {};

      if (this.localModel.usoInsumoFilter.fechaAltaDesde) {
        data.fechaAltaDesde = this.localModel.usoInsumoFilter.fechaAltaDesde;
      }
      if (this.localModel.usoInsumoFilter.fechaAltaHasta) {
        data.fechaAltaHasta = this.localModel.usoInsumoFilter.fechaAltaHasta;
      }
      if (this.localModel.usoInsumoFilter.fechaServicioDesde) {
        data.fechaServicioDesde = this.localModel.usoInsumoFilter.fechaServicioDesde;
      }
      if (this.localModel.usoInsumoFilter.fechaServicioHasta) {
        data.fechaServicioHasta = this.localModel.usoInsumoFilter.fechaServicioHasta;
      }
      if (this.localModel.usoInsumoFilter.producto) {
        data.productoId = this.localModel.usoInsumoFilter.producto.id;
      }
      if (this.localModel.usoInsumoFilter.estado) {
        data.estadoId = this.localModel.usoInsumoFilter.estado.id;
      }
      if (this.localModel.usoInsumoFilter.adicional) {
        data.adicionalId = this.localModel.usoInsumoFilter.adicional.id;
      }
      if (this.localModel.usoInsumoFilter.familia) {
        data.familiaId = this.localModel.usoInsumoFilter.familia.id;
      }
      if (this.localModel.usoInsumoFilter.proveedor) {
        data.proveedorId = this.localModel.usoInsumoFilter.proveedor.id;
      }
      if (this.localModel.usoInsumoFilter.marca) {
        data.marcaId = this.localModel.usoInsumoFilter.marca.id;
      }
      if (this.localModel.usoInsumoFilter.servicio) {
        data.servicioId = this.localModel.usoInsumoFilter.servicio.id;
      }
      if (this.localModel.usoInsumoFilter.ordenCabeceraNro) {
        data.ordenCabeceraNro = this.localModel.usoInsumoFilter.ordenCabeceraNro;
      }
      if (this.localModel.empleado) {
        data.empleadoId = this.localModel.empleado.id;
      }
      if (this.localModel.sucursal) {
        data.sucursalId = this.localModel.sucursal.id;
      }

    } else {
      data = Object.assign({}, this.model);

      console.log("ARMANDO FILTROS DE CONSULTA...")

      //data.fechaDesde = moment(data.fechaDesde, 'DD/MM/YYYY').toDate();
      //data.fechaHasta = moment(data.fechaHasta,'DD/MM/YYYY').toDate();

      /* validacion de fechas*/
      //if( data.fechaDesde > data.fechaHasta){
      //  ngNotify.set('La fecha Desde no puede ser mayor a la fecha Hasta', 'error');
       // return;
      //}

      //let data = Object.assign({}, this.model);
      let desde;
      let hasta;
      if (typeof data.fechaDesde.getMonth === 'function') {
        desde = data.fechaDesde;
      } else {
        desde = moment(data.fechaDesde, 'DD/MM/YYYY').toDate();
      }
      if (typeof data.fechaHasta.getMonth === 'function') {
        hasta = data.fechaHasta;
      } else {
        hasta = moment(data.fechaHasta, 'DD/MM/YYYY').toDate();
      }
  
      if (desde > hasta) {
        ngNotify.set('La fecha Desde no puede ser mayor a la fecha Hasta', 'error');
        return;
      }

      if (this.localModel.cliente) {
        data.clienteId = this.localModel.cliente.id;
      }
      if (this.localModel.empleado) {
        data.empleadoId = this.localModel.empleado.id;
      }
      if (this.localModel.sucursal) {
        data.sucursalId = this.localModel.sucursal.id;
      }
      if (this.localModel.producto) {
        data.productoId = this.localModel.producto.id;
      }
      if(this.localModel.marca){
        data.marcaId = this.localModel.marca.id;
      }
      if (this.localModel.numeroComprobante) {
        data.numeroComprobante = this.localModel.numeroComprobante;
      }
    }
    return data;
  }

  this.renderCliente = renderCliente.bind(this);
  function renderCliente(cliente) {
    let detalle = cliente.numeroDocumento ? `<small><strong>(${cliente.numeroDocumento})</strong></small>` : '';
    return `${cliente.razonSocial} ${detalle}`;
  }

  this.changeTipo = changeTipo.bind(this);

  function changeTipo() {
    if (this.localModel.tipoReporte.value === 'COMISION_VENTA') {
      this.localModel.cliente = undefined;
    } else {
      this.localModel.empleado = undefined;
    }
    this.localModel.formato = this.localModel.tipoReporte.formatos[0];
  }

  this.renderEmpleado = renderEmpleado.bind(this);

  function renderEmpleado(empleado) {
    let completo = empleado.nombre + ' ' + empleado.apellido;
    return completo;
  }

  this.loadClientes = loadClientes.bind(this);

  function loadClientes(query) {
    let filter = Filter.path('activo').eq(true);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('razonSocial').like(query))
        .or(Filter.path('numeroDocumento').like(query))
        .or(Filter.path('telefono').like(query)));
    }

    BasicFactory.setup('clientes');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  this.loadEmpleados = loadEmpleados.bind(this);
  function loadEmpleados(query) {
    let filter = Filter.path('activo').eq(true);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query)));
    }

    BasicFactory.setup('empleados');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  this.loadAdicionales = loadAdicionales.bind(this);
  function loadAdicionales(query, tipo) {
    let filter;

    if (tipo) {
      filter = Filter.path('tipo.value').eq(tipo);
    }

    if (query) {
      if (filter) {
        filter = filter.and(Filter.path('nombre').like(query));
      } else {
        filter = Filter.path('nombre').like(query);
      }
    }

    BasicFactory.setup('adicionales');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  this.loadInsumos = loadInsumos.bind(this);
  function loadInsumos(query) {
    let filter = Filter.path('categoria.clase.value').eq("Insumo");

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  this.loadServicios = loadServicios.bind(this);
  function loadServicios(query) {
    let filter = Filter.path('categoria.clase.value').eq("Servicio");

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  this.loadProductos = loadProductos.bind(this);
  function loadProductos(query) {
    let filter = Filter.path('categoria.clase.value').eq("Producto");

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  this.renderSucursal = renderSucursal.bind(this);

  function renderSucursal(item) {
    return `<small><strong>(${pad(item.codigo, 3)})</strong></small> - ${item.nombre}`;
  }

  this.filterAdicional = filterAdicional.bind(this);
  function filterAdicional(adicional) {
    // Si no hay servicio seleccionado mostrar todos los adicionales
    if (!this.localModel.usoInsumoFilter.servicio) {
      return true;
    } else {
      // Si hay servicio, mostrar solo los adicionales del servicio

      let idsAdicionalesServicio;
      const detallesServicio = this.localModel.usoInsumoFilter.servicio.detalles;
      if (detallesServicio) {
        idsAdicionalesServicio = detallesServicio.map((detalle)=>{return detalle.adicional && detalle.adicional.id});
      }

      return idsAdicionalesServicio && idsAdicionalesServicio.includes(adicional.id);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/list/reportes.component.js